import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../Navigation/Navigation';
import Footer from '../General/Footer';

class HelpPage extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <div className="help-page">
                <Navigation auth={this.props.auth} {...this.props} />

                <div className="help-hero">
                    <div className="container">
                        <h1>Centre d'aide</h1>
                        <p>Tout ce dont vous avez besoin pour utiliser OURides</p>
                    </div>
                </div>

                <div className="help-content">
                    <section className="how-it-works">
                        <div className="container">
                            <h2>Comment ça marche ?</h2>
                            <div className="steps-grid">
                                <div className="step-card">
                                    <div className="step-number">1</div>
                                    <h3>Recherchez</h3>
                                    <p>Trouvez l'aventure parfaite parmi notre sélection de véhicules et d'expériences.</p>
                                </div>
                                <div className="step-card">
                                    <div className="step-number">2</div>
                                    <h3>Réservez</h3>
                                    <p>Envoyez une demande de réservation et discutez avec le propriétaire.</p>
                                </div>
                                <div className="step-card">
                                    <div className="step-number">3</div>
                                    <h3>Profitez</h3>
                                    <p>Vivez une expérience inoubliable en toute sécurité.</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="guides-section">
                        <div className="container">
                            <h2>Guides et Ressources</h2>
                            <p className="section-subtitle">Téléchargez nos guides détaillés pour vous accompagner.</p>

                            <div className="guides-grid">
                                <div className="guide-card">
                                    <div className="guide-icon">📄</div>
                                    <div className="guide-info">
                                        <h3>Guide du Locataire</h3>
                                        <p>Tout savoir sur la location</p>
                                    </div>
                                    <button className="btn-download" onClick={() => alert('Téléchargement bientôt disponible')}>
                                        Télécharger
                                    </button>
                                </div>

                                <div className="guide-card">
                                    <div className="guide-icon">🛥️</div>
                                    <div className="guide-info">
                                        <h3>Guide du Propriétaire</h3>
                                        <p>Gérer vos annonces et revenus</p>
                                    </div>
                                    <button className="btn-download" onClick={() => alert('Téléchargement bientôt disponible')}>
                                        Télécharger
                                    </button>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="contact-section">
                        <div className="container">
                            <h2>Encore des questions ?</h2>
                            <p>Notre équipe est là pour vous aider.</p>
                            <a href="mailto:support@ourides.com" className="btn-contact">Contacter le support</a>
                        </div>
                    </section>
                </div>

                <Footer />
            </div>
        );
    }
}

export default HelpPage;
